var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Divider, Grid, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setIsTaskDetailsDataUpdated } from "../../../redux/commonSlice";
import { MuiCheckBox } from "../../atoms/checkBox";
import { InputBox } from "../../atoms/input";
import { MuiStack } from "../../atoms/stackComponent";
var PrecheckCustomForm = function (props) {
    var data = props.data, onChangeList = props.onChangeList, isDataUpdated = props.isDataUpdated, isDisabled = props.isDisabled;
    var _a = useState(data), list = _a[0], setList = _a[1];
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var upSM = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var dowMd = useMediaQuery(function (theme) { return theme.breakpoints.down("md"); });
    var IS_TABLET = upSM && dowMd;
    var upXS = useMediaQuery(function (theme) { return theme.breakpoints.up("xs"); });
    var downSM = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var IS_MOBILE = upXS && downSM;
    var dispatch = useDispatch();
    useEffect(function () {
        setList(data);
    }, [data]);
    var handleOnChangeTextInput = function (event, QuestionGroupItemIndex, QuestionItemIndex) {
        var _event$target$value;
        var updatedQueGroupsList = __spreadArray([], list, true);
        var updatedQuestionGrp = updatedQueGroupsList[QuestionGroupItemIndex];
        var updatedQuestionItem = updatedQuestionGrp.Questions[QuestionItemIndex];
        updatedQuestionItem.ResponseValue = (_event$target$value = event.target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "";
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedQueGroupsList[QuestionGroupItemIndex] = updatedQuestionGrp;
        onChangeList(updatedQueGroupsList);
        dispatch(setIsTaskDetailsDataUpdated(true));
        isDataUpdated(true);
    };
    var handleOnClickCheckbox = function (event, QuestionGroupItemIndex, QuestionItemIndex) {
        var updatedQueGroupsList = __spreadArray([], list, true);
        var updatedQuestionGrp = updatedQueGroupsList[QuestionGroupItemIndex];
        var updatedQuestionItem = updatedQuestionGrp.Questions[QuestionItemIndex];
        updatedQuestionItem.ResponseValue = updatedQuestionItem.ResponseValue === "true" ? "false" : "true"; // reverting value 
        updatedQuestionGrp.Questions[QuestionItemIndex] = updatedQuestionItem;
        updatedQueGroupsList[QuestionGroupItemIndex] = updatedQuestionGrp;
        onChangeList(updatedQueGroupsList);
        dispatch(setIsTaskDetailsDataUpdated(true));
        isDataUpdated(true);
    };
    var RenderQuestionByType = function (QuestionItem, QuestionGroupItemIndex, QuestionItemIndex) {
        // console.log(QuestionGroupItemIndex, QuestionItemIndex);
        switch (QuestionItem.ControlName) {
            case "Text":
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "column",
                    spacing: 0
                }, QuestionItem.IsDisplay && /*#__PURE__*/ React.createElement(Typography, {
                    variant: "h3",
                    sx: {
                        textTransform: 'capitalize'
                    }
                }, QuestionItem.Title), /*#__PURE__*/ React.createElement(InputBox, {
                    placeholder: "Enter ".concat(QuestionItem.Title),
                    fullWidth: true,
                    size: "small",
                    value: QuestionItem.ResponseValue,
                    name: QuestionItem.Title,
                    onChange: function (event) { return handleOnChangeTextInput(event, QuestionGroupItemIndex, QuestionItemIndex); },
                    id: QuestionItem.Title,
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    style: {
                        opacity: isDisabled ? 0.7 : 1,
                        padding: 0
                    }
                }));
            case "CheckBox":
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    alignItems: 'center',
                    paddingX: 1.5
                }, /*#__PURE__*/ React.createElement(MuiStack, {
                    justifyContent: 'center'
                }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
                    sx: {
                        "& .MuiCheckbox-root": {
                            padding: 0
                        }
                    },
                    checkBoxValue: QuestionItem.ResponseValue === "true",
                    handleChange: function (event) { return handleOnClickCheckbox(event, QuestionGroupItemIndex, QuestionItemIndex); },
                    id: 'inventory-checklist-checkbox',
                    disabled: isDisabled !== null && isDisabled !== void 0 ? isDisabled : false,
                    style: {
                        opacity: isDisabled ? 0.7 : 1
                    }
                })), /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                    fontSize: 'base',
                    fontWeight: 'medium',
                    sx: {
                        textTransform: 'capitalize'
                    }
                }, QuestionItem.Title)));
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    return /*#__PURE__*/ React.createElement(MuiStack, {
        direction: 'column',
        width: '100%'
    }, list.map(function (QuestionGroupItem, QuestionGroupItemIndex) {
        return /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            key: QuestionGroupItemIndex,
            paddingY: 1,
            spacing: 1
        }, /*#__PURE__*/ React.createElement(Typography, {
            fontSize: 'lg',
            fontWeight: 'medium',
            sx: {
                textTransform: 'capitalize'
            }
        }, QuestionGroupItem.QuestionGroupName, " "), /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'row',
            spacing: 0
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            spacing: {
                sm: 2,
                xs: 0
            },
            gap: {
                xs: 2,
                sm: 0
            },
            columns: {
                xs: 2,
                sm: 8,
                md: 12
            }
        }, QuestionGroupItem.Questions.map(function (QuestionItem, QuestionItemIndex) {
            return /*#__PURE__*/ React.createElement(Grid, {
                sx: {
                    pl: QuestionItem.ControlName === "Text" && IS_MOBILE ? '0px !important' : ''
                },
                item: true,
                xs: 12,
                sm: 4,
                md: 6,
                justifyContent: 'space-between',
                key: QuestionItemIndex,
                direction: 'column'
            }, RenderQuestionByType(QuestionItem, QuestionGroupItemIndex, QuestionItemIndex));
        }))), QuestionGroupItem.QuestionGroupName == 'Inventory checklist' ? /*#__PURE__*/ React.createElement(Divider, {
            sx: {
                paddingTop: '8px'
            }
        }) : /*#__PURE__*/ React.createElement(React.Fragment, null));
    }));
};
export default PrecheckCustomForm;
